export interface ForemanJobImport {
  foremanJobID: string | null;
  jobID: string | null;
  vpJobID: string | null;
  name: string | null;
  displayName: string | null;
  isActive: boolean;
  order: number;
  companyID: string | null;
  vpCompanyID: number | null;
  workStatus: string | null;
  timekeeper: string | null;
  /** Display name of the per-job Job Owner default (#30008). */
  jobOwner?: string | null;
  employeeCount: number;
  equipmentCount: number;
  laborCount: number;
  eqUsageCount: number;
  workOrders: ForemanPhaseImport[];
}

export interface ForemanPhaseImport {
  foremanPhaseID: string;
  phaseID: string | null;
  phaseName: string;
}
